module.exports = __webpack_public_path__ + "static/media/taxa1.5250a7be.png";